import React, { Component } from 'react'
import DashboardTodoRow from './DashboardTodoRow'
import getDashboardTodo from '../../../services/dashboardTodoService'
import Loading from '../../production/partials/Loading'

class DashboardTodo extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            searchResults: [],
            searchResultsNextDay: [],
            type: -1,
            filterOnUserId: this.props.filterOnUserId
        }
    }

    componentDidMount() {
        this.getTodos()
    }

    componentDidUpdate(prevProps) {
        if (parseInt(prevProps.filterOnUserId) != parseInt(this.props.filterOnUserId)) {
            this.getTodos()
        }
    }

    handleChangeType = async type => {
        this.setState({ type }, () => {
            this.getTodos()
        })
    }

    getTodos = async () => {
        const { type } = this.state
        let searchResults = []
        let searchResultsNextDay = []

        try {
            let response = await getDashboardTodo(type, this.props.filterOnUserId, 0)
            let nextWorkingDay = new Date()
            let dayOffset = 1
            
            searchResults = response.data
            nextWorkingDay.setDate(nextWorkingDay.getDate() + dayOffset)

            while (nextWorkingDay.getDay() == 0 || nextWorkingDay.getDay() == 6) {
                nextWorkingDay.setDate(nextWorkingDay.getDate() + 1)
                dayOffset++
            }

            response = await getDashboardTodo(type, this.props.filterOnUserId, dayOffset)
            searchResultsNextDay = response.data
        } catch (e) {}

        this.setState({
            loading: false,
            searchResults,
            searchResultsNextDay,
            type
        })
    }

    render() {
        const { searchResults, searchResultsNextDay } = this.state
        let nextWorkingDayLabel = 'Att göra imorgon'
        let tomorrow = new Date()
        let rows = []
        let rowsNextDay = []

        let view = null
        
        tomorrow.setDate(tomorrow.getDate() + 1)

        if (tomorrow.getDay() == 0 || tomorrow.getDay() == 6) {
            nextWorkingDayLabel = 'Att göra på måndag'
        }

        if (searchResults.length > 0) {
            searchResults.map((row, index) => {
                rows.push(                    
                    <DashboardTodoRow
                        key={ index }
                        data={ row }
                    />
                )
            })
        }

        if (searchResultsNextDay.length > 0) {
            searchResultsNextDay.map((row, index) => {
                rowsNextDay.push(
                    <DashboardTodoRow
                        key={ index }
                        data={ row }
                    />
                )
            })
        }

        // var today = rows.length > 0 ? rows : <span dangerouslySetInnerHTML={'Bra jobbat, allt är klart &#128640;'}></span>;

        if (this.state.loading) {
            view = <Loading />
        } else {
            view = <div className="todo__inner">
                <div className="todo__inner--header">
                    <h3 className="todo__inner__title">Att göra idag</h3>
                    {/*
                    <ul className="todo__inner__palette">
                        <li className="todo__inner__palette__item">
                            <span className="todo__inner__palette__item__color todo__inner__palette__item__color--turkos"></span>
                            = Accepterad offert
                        </li>
                        <li className="todo__inner__palette__item">
                            <span className="todo__inner__palette__item__color todo__inner__palette__item__color--green"></span>
                            = Redo för leverans
                        </li>
                        <li className="todo__inner__palette__item">
                            <span className="todo__inner__palette__item__color todo__inner__palette__item__color--blue"></span>
                            = Ej påbörjad
                        </li>
                        <li className="todo__inner__palette__item">
                            <span className="todo__inner__palette__item__color todo__inner__palette__item__color--yellow"></span>
                            = Påbörjad
                        </li>
                        <li className="todo__inner__palette__item">
                            <span className="todo__inner__palette__item__color todo__inner__palette__item__color--orange"></span>
                            = Försenad
                        </li>
                        <li className="todo__inner__palette__item">
                            <span className="todo__inner__palette__item__color todo__inner__palette__item__color--red"></span>
                            = Ej levererad
                        </li>
                        <li className="todo__inner__palette__item">
                            <span className="todo__inner__palette__item__color todo__inner__palette__item__color--white"></span>
                            = Meddelande
                        </li>
                    </ul>
                    */}
                </div>

                <ul className="todo__inner__list">{ rows.length > 0 ? rows : 
                    <span style={{ display: 'flex', alignItems: 'center', marginTop: '-35px'}}><span>Bra jobbat, allt är klart!</span><span style={{ marginLeft:'10px', fontSize: '2rem'}} dangerouslySetInnerHTML={{ __html:'&#9749;'  }}></span></span>}
                </ul>

                <h3 className="todo__inner__title">{ nextWorkingDayLabel }</h3>
                <ul className="todo__inner__list">{ rowsNextDay.length > 0 ? rowsNextDay : 
                    <span style={{ display: 'flex', alignItems: 'center', marginTop: '-35px' }}><span>Här var det tomt </span><span style={{ marginLeft:'10px', fontSize: '2rem'}} dangerouslySetInnerHTML={{ __html:'&#128640;'  }}></span></span>}
                </ul>
            </div>
        }

        setTimeout(() => {
            // Remove
            jQuery('.todo__inner__list__row__item').tooltip('dispose');
            jQuery('.todo__inner__list__row__item').tooltip({show: null});
        }, 200);

        return <div className="todo">
            { view }
        </div>
    }
}

export default DashboardTodo;
